<!-- ── New Customer Slide-in Drawer ────────────────────────────────────── -->
<app-new-customer-drawer
  #newCustomerDrawer
  [opened]="newCustomerDrawerOpen"
  [customerNameTaken]="customerNameTaken"
  [customerNameChecking]="customerNameChecking"
  [allCustomers]="allCustomers"
  (closed)="closeNewCustomerDrawer()"
  (saved)="onNewCustomerSaved($event)"
  (nameInputChange)="onNewCustomerNameChange($event)">
</app-new-customer-drawer>

<mat-sidenav-container class="customer-sidenav-host">
  <mat-sidenav-content>
    <div class="customer-page">
      <mat-card class="customer-toolbar-card">
        <mat-card-content class="customer-toolbar">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search customers</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="Name, GST, email, phone">
          </mat-form-field>

          <span class="toolbar-spacer"></span>

          <button mat-raised-button color="primary" (click)="openAddDrawer()">
            <mat-icon>add</mat-icon>
            Add Customer
          </button>
        </mat-card-content>
      </mat-card>

      <mat-card class="customer-table-card">
        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

        <div class="table-wrap">
          <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let row">
                <button class="name-link" type="button" (click)="$event.stopPropagation(); onNameClick(row)">
                  {{ row.name || '—' }}
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="gstNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>GST Number</th>
              <td mat-cell *matCellDef="let row">{{ row.gstNumber || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
              <td mat-cell *matCellDef="let row">{{ getCustomerEmail(row) }}</td>
            </ng-container>

            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
              <td mat-cell *matCellDef="let row">{{ getCustomerPhone(row) }}</td>
            </ng-container>

            <ng-container matColumnDef="updatedOn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
              <td mat-cell *matCellDef="let row">{{ row.updatedOn | date: 'dd MMM yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-col">Actions</th>
              <td mat-cell *matCellDef="let row" class="actions-col">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item (click)="openEditDrawer(row)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item *ngIf="canArchive" (click)="archiveCustomer(row)">
                    <mat-icon>inventory_2</mat-icon>
                    <span>Archive</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                <div class="no-data-message">
                  <mat-icon aria-hidden="true">person</mat-icon>
                  <p>No customers found — click "Add Customer" to create one.</p>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="pageSize"
          showFirstLastButtons>
        </mat-paginator>
      </mat-card>
    </div>
  </mat-sidenav-content>

  <mat-sidenav class="customer-drawer" mode="over" position="end" [opened]="drawerOpen" (closedStart)="closeDrawer()">
    <div class="drawer-header" [class.drawer-header--detail]="drawerMode === 'detail'">
      <div class="drawer-title-wrap">
        <mat-icon *ngIf="drawerMode === 'detail'">groups</mat-icon>
        <h3>{{ drawerMode === 'detail' ? 'Customer Details' : (formMode === 'edit' ? 'Edit Customer' : 'New Customer') }}</h3>
      </div>
      <button mat-icon-button class="drawer-close-btn" (click)="closeDrawer()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="drawer-body" *ngIf="drawerMode === 'detail'">
      <ng-container *ngIf="selectedCustomer as customer; else detailLoading">
        <div class="detail-content">
          <div class="detail-chip-row">
            <span class="detail-chip">
              <mat-icon class="detail-chip-icon">badge</mat-icon>
              Customer
            </span>
          </div>

          <h3 class="detail-name">{{ customer.name || '—' }}</h3>

          <div class="detail-item detail-item--first">
            <mat-icon class="detail-item-icon">location_on</mat-icon>
            <div class="detail-item-content">
              <div class="label">Address</div>
              <div class="value">{{ customer.address || '—' }}</div>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-item-icon">language</mat-icon>
            <div class="detail-item-content">
              <div class="label">Website</div>
              <div class="value">{{ customer.website || '—' }}</div>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-item-icon">receipt_long</mat-icon>
            <div class="detail-item-content">
              <div class="label">GST Number</div>
              <div class="value">{{ customer.gstNumber || '—' }}</div>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-item-icon">person</mat-icon>
            <div class="detail-item-content">
              <div class="label">Contact Person</div>
              <div class="value">{{ customer.contactPerson.name || '—' }}</div>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-item-icon">email</mat-icon>
            <div class="detail-item-content">
              <div class="label">Contact Email</div>
              <div class="value">{{ customer.contactPerson.email || '—' }}</div>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-item-icon">phone</mat-icon>
            <div class="detail-item-content">
              <div class="label">Contact Phone</div>
              <div class="value">{{ customer.contactPerson.mobile || '—' }}</div>
            </div>
          </div>

          <div class="detail-meta">
            <mat-divider></mat-divider>
            <p class="meta-row">
              <mat-icon class="meta-icon">schedule</mat-icon>
              Updated {{ customer.updatedOn | date: 'dd MMM yyyy' }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-template #detailLoading>
        <div class="detail-loading">Loading customer details...</div>
      </ng-template>
    </div>

    <div class="drawer-body" *ngIf="drawerMode === 'form'">
      <mat-form-field appearance="outline" class="drawer-field drawer-field--name" subscriptSizing="dynamic">
        <mat-label>Name *</mat-label>
        <mat-icon matPrefix>business</mat-icon>
        <input
          matInput
          [(ngModel)]="formCustomer.name"
          #nameModel="ngModel"
          (ngModelChange)="onCustomerNameInput($event)"
          required>
      </mat-form-field>
      <div class="drawer-inline-hint" *ngIf="nameModel.hasError('required') && (nameModel.touched || nameModel.dirty)">
        Name is required
      </div>
      <div class="drawer-inline-hint" *ngIf="customerNameChecking && !nameModel.hasError('required')">
        Checking availability...
      </div>
      <div class="drawer-inline-error" *ngIf="!nameModel.hasError('required') && customerNameTaken">
        <mat-icon class="error-icon">error</mat-icon>
        Name already exists
      </div>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>Address</mat-label>
        <mat-icon matPrefix>location_on</mat-icon>
        <input matInput [(ngModel)]="formCustomer.address">
      </mat-form-field>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>Website</mat-label>
        <mat-icon matPrefix>language</mat-icon>
        <input matInput [(ngModel)]="formCustomer.website">
      </mat-form-field>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>GST Number</mat-label>
        <mat-icon matPrefix>receipt_long</mat-icon>
        <input matInput [(ngModel)]="formCustomer.gstNumber">
      </mat-form-field>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>Contact Person</mat-label>
        <mat-icon matPrefix>person</mat-icon>
        <input matInput [(ngModel)]="formCustomer.contactPerson.name">
      </mat-form-field>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>Contact Email</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input matInput [(ngModel)]="formCustomer.contactPerson.email" type="email">
      </mat-form-field>

      <mat-form-field appearance="outline" class="drawer-field">
        <mat-label>Contact Phone</mat-label>
        <mat-icon matPrefix>phone</mat-icon>
        <input matInput [(ngModel)]="formCustomer.contactPerson.mobile">
      </mat-form-field>
    </div>

    <div class="drawer-footer" *ngIf="drawerMode === 'form'">
      <button mat-stroked-button (click)="closeDrawer()" [disabled]="saving">Cancel</button>
      <button mat-flat-button color="primary" (click)="saveCustomer()" [disabled]="isSaveButtonDisabled()">
        {{ saving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
